const booking = {
  bookingInformation: "Maklumat Tempahan", // translated 
  cancellationPolicy: "Polisi Pembatalan", // translated 
  ourCancellationPolicy: "Polisi Pembatalan Kami", // translated 
  thisAupersedesAnyCancellationPolicyInRemarksAbove:
    "Ini menggantikan sebarang dasar pembatalan dalam kenyataan di atas.", // translated 
  thisBookingIsNonNefundable: "Tempahan ini tidak boleh dikembalikan", // translated 
  paymentTerms: "Syarat Pembayaran", // translated 
  paymentWillBeTakenFromYourDefault: "Bayaran akan diambil dari akaun lalai anda", // translated 
  paymentMethod: "kaedah pembayaran", // translated 
  afterTheFreeCancellationPeriodIfApplicable:
    "selepas tempoh pembatalan percuma jika berkenaan", // translated 
  prebook: "Pra-tempah", // translated 
  guests: "Tetamu", // translated 
  payment: "Pembayaran", // translated 
  byClicking: "Dengan mengklik", // translated 
  youAreAgreeingToOur: "anda bersetuju dengan kami", // translated 
  termsAndConditions: "Terma dan Syarat", // translated 
  lastBookableDate: "Tarikh Tempahan Terakhir", // translated 
  customerRemarksTextfield: "Catatan Pelanggan", // translated 
  request: "Permintaan", // translated 
};







export default booking;
